import { getDecisionColumns } from "@/pages/GovernancePage/components/molecules/AiPolicyDecision"

import type { RowClick } from "@/hooks/useLinkDrawerTooltip"
import type { ORDER_BY_PROPS } from "@/hooks/useOrderBy"
import type { TFunction } from "@/hooks/useTranslation"

export const getColumnsTable = (
  t: TFunction,
  onRowClick: RowClick,
  sorter: Omit<ORDER_BY_PROPS, "onSorterChange">
) => {
  const columns = getDecisionColumns(t, onRowClick, sorter)

  return [
    { ...columns.time, width: "12%" },
    { ...columns.platform, width: "11%" },
    // Wide enough for an agent's, an MCP server's or a workload's usual name
    { ...columns.agent, width: "16%" },
    { ...columns.tool, width: "14%" },
    { ...columns.policy, width: "17%" },
    { ...columns.action, width: "10%" },
    { ...columns.outcome, width: "10%" },
    { ...columns.enforcedBy, width: "10%" }
  ]
}
